import { Button, Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useSyncStockErpProduct } from "../useCases/useSyncStockErpProduct";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/ui/chakra/dialog";

interface ConfirmDialogSyncStockProps {
  isOpen: boolean;
  onClose: () => void;
  erpProductId: string;
  oldStock: number;
  newStock: number;
}

const ConfirmDialogSyncStock: React.FC<ConfirmDialogSyncStockProps> = ({
  isOpen,
  onClose,
  oldStock,
  newStock,
  erpProductId,
}) => {
  const [isSending, setIsSending] = useState(false);

  const { mutate } = useSyncStockErpProduct();

  const handleOnSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSending(true);

    mutate(erpProductId, {
      onSuccess: () => {
        setIsSending(false);
        onClose();
      },
      onError: () => {
        setIsSending(false);
      },
    });
  };

  const handleOnClose = () => {
    setIsSending(false);

    onClose();
  };

  return (
    <DialogRoot isOpen={isOpen} onClose={handleOnClose} isCentered size="md">
      <DialogContent>
        <form onSubmit={handleOnSubmit}>
          <DialogHeader pb={2}>
            <DialogTitle>Sincronizar stock</DialogTitle>
          </DialogHeader>
          <DialogCloseTrigger />

          <DialogBody pt={2} pb={6}>
            <Text color="fg.muted" mb={6}>
              ¿Está seguro que desea sincronizar el stock de los productos?
            </Text>

            <Flex
              direction="column"
              gap={3}
              bg="bg.subtle"
              p={4}
              borderRadius="lg"
            >
              <Flex justify="space-between" align="center">
                <Text color="fg.muted" fontWeight="medium">
                  Stock actual:
                </Text>
                <Text fontSize="lg" fontWeight="semibold">
                  {oldStock}
                </Text>
              </Flex>

              <Flex justify="space-between" align="center">
                <Text color="fg.muted" fontWeight="medium">
                  Nuevo stock desde ERP:
                </Text>
                <Text fontSize="lg" fontWeight="semibold" color="brand.fg">
                  {newStock}
                </Text>
              </Flex>
            </Flex>
          </DialogBody>

          <DialogFooter>
            <Button variant="outline" onClick={handleOnClose} type="button">
              Cerrar
            </Button>
            <Button colorPalette="brand" type="submit" loading={isSending}>
              Enviar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </DialogRoot>
  );
};

export default ConfirmDialogSyncStock;
